<mat-tab-group (selectedTabChange)="onTabChange($event)">
    <mat-tab label="I Viewed">
        <section class="my_friends">
            <ul class="friends-section main-member-list-wrap no-list" #scrollContainer>
                <li id="friend9" class="member-detail-wrap" *ngFor="let view of viewed">
                    <figure class="img-holder">
                        <a [routerLink]="['/member-profile',view?.username,'Profile']">
                            <img src="{{view.profile_pic}}" class="dsp_img3 iviewed-img" alt="Shawn">
                        </a>
                        <div class="wpee-user-status wpee-online"></div>
                    </figure>
                    <div class="user-details">
                        <h6 class="member-user-name">
                            <a>{{view?.username}}</a>
                            <span class="online dspdp-online-status">
                                <span class="dspdp-status-on {{view.isOnline==true?'':'offline'}}" online=""></span>
                            </span>
                        </h6>
                        <div class="user-detail-content">
                            <p>
                                {{view?.age}}
                                <span><fa-icon
                                        [icon]="view?.gender?.name === 'Female' ? famale : fafemale"></fa-icon></span>
                                <span data-label="member-label">
                                    from </span>
                                <br>
                                {{view?.country?.name}} {{view?.city?.name}}
                            </p>
                        </div>
                    </div>
                </li>
                <div [ngClass]="{ 'shine': view_responce }">

                </div>
                <div class="profile-section-content" *ngIf="!view_responce && viewed.length == 0">
                    <div id="m_list_friend" class="profile-section-content profile-friends-list">
                        <div class="box-border">
                            <div class="box-pedding">
                                <div class="page-not-found">
                                    <span class="dsp_span_pointer"
                                        style="text-align: center; display: block; font-weight: bold;">
                                        No Viewed Records</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </ul>
        </section>
    </mat-tab>
    <mat-tab label="Viewed Me">
        <section class="my_friends">
            <ul class="friends-section main-member-list-wrap no-list" >
                <li id="friend9" class="member-detail-wrap" *ngFor="let viewMe of viewedMe">
                    <figure class="img-holder">
                        <a [routerLink]="['/member-profile',viewMe?.username,'Profile']">
                            <img src="{{viewMe?.profile_pic}}" class="dsp_img3 iviewed-img" alt="Shawn">
                        </a>
                        <div class="wpee-user-status wpee-online"></div>
                    </figure>
                    <div class="user-details">
                        <h6 class="member-user-name">
                            <a>{{viewMe?.username}}</a>
                            <span class="online dspdp-online-status">
                                <span class="dspdp-status-on {{viewMe.isOnline==true?'':'offline'}}" online=""></span>
                            </span>
                        </h6>
                        <div class="user-detail-content">
                            <p>
                                {{viewMe.age}}
                                <span><fa-icon [icon]="viewMe?.id === 1 ? famale : fafemale"></fa-icon></span>

                                <span data-label="member-label">
                                    from </span>
                                <br>
                                {{viewMe?.country?.name}} {{viewMe?.city?.name}}
                            </p>
                        </div>
                    </div>
                </li>
                <div [ngClass]="{ 'shine': view_responce }">

                </div>
                <div class="profile-section-content" *ngIf="!view_responce && viewedMe.length == 0">
                    <div id="m_list_friend" class="profile-section-content profile-friends-list">
                        <div class="box-border">
                            <div class="box-pedding">
                                <div class="page-not-found">
                                    <span class="dsp_span_pointer"
                                        style="text-align: center; display: block; font-weight: bold;">
                                        No Viewed Records</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </ul>
        </section>
    </mat-tab>
</mat-tab-group>